import { Component, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '@features/auth/services/auth.service';

const DISMISS_KEY = 'grace_banner_dismissed_until';

@Component({
  selector: 'app-grace-period-banner',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './grace-period-banner.component.html',
  styleUrls: ['./grace-period-banner.component.scss'],
})
export class GracePeriodBannerComponent {
  private dismissed = signal(this.isDismissedForToday());

  show = computed(() => {
    if (!this.authService.isCancellingAtPeriodEnd()) return false;
    return !this.dismissed();
  });

  periodEndsAt = computed(() => this.authService.currentPeriodEndsAt());

  constructor(private authService: AuthService) {}

  dismiss(): void {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    localStorage.setItem(DISMISS_KEY, tomorrow.toISOString());
    this.dismissed.set(true);
  }

  private isDismissedForToday(): boolean {
    const until = localStorage.getItem(DISMISS_KEY);
    if (!until) return false;
    return new Date() < new Date(until);
  }
}
